import React from 'react';
import { useSelector } from 'react-redux';
import { Spin } from 'antd';

import selectors from '../../store/selectors';
import { useFetchDonationPurposes } from '../../api/actions/useFetchDonationPurposes';
import { Footer } from '../Layout';
import { useFetchAccountOptions } from '../../api/actions/useFetchAccountOptions';

import ParishInfo from './ParishInfo';
import DonationForm from './DonationForm';

const DonationWrapper = () => {
  const parishData = useSelector(selectors.getAccountData);

  const isFetchingAccountOptions = useFetchAccountOptions();
  const { loading: loadingDonationPurposes, payload: donationPurposes } =
    useFetchDonationPurposes();

  return (
    <>
      <main className="d-flex flex-column flex-lg-row flex-grow-1 flex-shrink-0">
        <ParishInfo
          fullName={parishData.full_name}
          backgroundImageUrl={parishData.background_image_url}
          address={parishData.address}
        />

        <div className="donation-form-wrapper mt-5 mt-lg-0 px-lg-5 d-flex justify-content-start flex-shrink-0">
          <div className="container-lg px-lg-0 h-100 d-flex flex-column justify-content-center mx-a">
            {isFetchingAccountOptions || loadingDonationPurposes ? (
              <Spin />
            ) : (
              <DonationForm
                accountId={parishData.accountId}
                getRegulations={parishData.getRegulations}
                csrf={parishData.csrf}
                donationPurposes={donationPurposes}
              />
            )}
          </div>
        </div>
      </main>
      <Footer isAbsolute />
    </>
  );
};

DonationWrapper.propTypes = {};

export default DonationWrapper;
